/* eslint-disable no-console */
import { takeLatest, put, select, call } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { setNotification, searchElementMatch } from 'utils';
import * as CostTypes from '../types/costTypes';
import * as CostApi from '../api/costApi';
import { getConfigurationsApi } from '../api/configurationApi';
import * as CostActions from '../actions/costActions';

const getLayout = state => state.layout;
const getCost = state => state.cost;

// L O A D   C O S T S
function* loadCostsSaga() {
    const { locale } = yield select(getLayout);
    const { offset, limit, filters, sort } = yield select(getCost);

    try {
        const sendFilters = {
            all: true,
        };

        const params = {
            filter: JSON.stringify(sendFilters),
            offset,
            limit,
        };

        if (filters.id !== '') {
            sendFilters.id = filters.id;
        }

        if (filters['name.translate'] !== '') {
            sendFilters['name.translate'] = searchElementMatch(filters['name.translate'], locale);
        }

        if (filters['configuration_property.carrier_id'].length > 0) {
            sendFilters['configuration_property.carrier_id'] = filters['configuration_property.carrier_id'];
        }

        if (filters['configuration_property.property_value_id'].length > 0) {
            sendFilters.and = filters['configuration_property.property_value_id'].map(cp => ({
                'configuration_property.property_value_id': cp,
            }));
        }

        if (filters.configuration_type.length > 0) {
            sendFilters.configuration_type = filters.configuration_type;
        }

        if (filters['cost_durations.partner_id'].length > 0) {
            sendFilters['cost_durations.partner_id'] = filters['cost_durations.partner_id'];
        }

        params.filter = JSON.stringify(sendFilters);

        if (sort !== null) {
            const sortInt = sort.type === 'asc' ? 1 : -1;

            if (sort.key === 'name') {
                params.sort_by = JSON.stringify({ 'name.original_name': sortInt });
            } else if (sort.key === 'created_at') {
                params.sort_by = JSON.stringify({ created_at: sortInt });
            }
        }

        const result = yield getConfigurationsApi(params);

        if (result.status === 200) {
            yield put(CostActions.loadCostsRes(result.data));
        }
    } catch (e) {
        console.log(e);
    }
}

export function* loadCostsWatcher() {
    yield takeLatest(CostTypes.LOAD_COSTS, loadCostsSaga);
}
// L O A D   C O S T S


// A D D   C O S T
function* addCostSaga(action) {
    const { locale } = yield select(getLayout);

    try {
        const result = yield CostApi.addCostApi(action.data);

        if (result.status === 202) {
            setNotification('success', locale, 'global.success', 'costs.addCostSuccess');
            yield put(CostActions.addCostRes(action.data.configuration_id));
            yield delay(100);
            yield put(CostActions.addCostReq(action.data.configuration_id));
            yield put({ type: CostTypes.LOAD_COSTS });
            yield call(loadCostsSaga, {});
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(CostActions.addCostErr(action.data.configuration_id));
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', 'costs.addCostError');
        yield put(CostActions.addCostErr(action.data.configuration_id));
        console.log(e);
    }
}

export function* addCostWatcher() {
    yield takeLatest(CostTypes.ADD_COST, addCostSaga);
}
// A D D   C O S T


// E D I T   C O S T
function* editCostSaga(action) {
    const { locale } = yield select(getLayout);

    try {
        const result = yield CostApi.editCostApi(action.data);

        if (result.status === 202) {
            setNotification('success', locale, 'global.success', 'costs.editCostSuccess');
            yield put(CostActions.editCostRes(action.data.configuration_id));
            yield delay(100);
            yield put(CostActions.editCostReq(action.data.configuration_id));
            yield call(loadCostsSaga, {});
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(CostActions.editCostErr(action.data.configuration_id));
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', 'costs.editCostError');
        yield put(CostActions.editCostErr(action.data.configuration_id));
        console.log(e);
    }
}

export function* editCostWatcher() {
    yield takeLatest(CostTypes.EDIT_COST, editCostSaga);
}
// E D I T   C O S T


// T O G G L E   C O S T   S T A T U S
function* toggleCostStatusSaga(action) {
    const { locale } = yield select(getLayout);
    const { ids, status } = action;

    try {
        const params = {
            bulk: ids.map(c => ({
                cost_and_duration_id: c,
                status: status === 'enable',
            })),
        };

        const result = yield CostApi.toggleCostStatusApi(params);

        if (result.status === 202) {
            setNotification('success', locale, 'global.success', `costs.notification.toggleStatus.${status}.success`);
            yield put(CostActions.toggleCostStatusRes());

            yield call(loadCostsSaga, {});
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(CostActions.toggleCostStatusErr());
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', `costs.notification.toggleStatus.${status}.error`);
        yield put(CostActions.toggleCostStatusErr());
        console.log(e);
    }
}
export function* toggleCostStatusWatcher() {
    yield takeLatest(CostTypes.TOGGLE_COST_STATUS, toggleCostStatusSaga);
}
// T O G G L E   C O S T   S T A T U S
